module.exports = __webpack_public_path__ + "img/build2.2d9b0c3c.jpeg";